module.exports = __webpack_public_path__ + "static/media/all_about_shipping@2x.d4bbd60f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/all_about_shipping@2x.png
 ** module id = 1998
 ** module chunks = 44
 **/